import QTabs from './src/QTabs';

QTabs.install = Vue => {
  Vue.component(QTabs.name, QTabs);
};

export default QTabs;
